// @flow
import React from 'react';
import PrettyNumber from 'app/common/react/i18n/PrettyNumber';
import { Box, Icon, Text } from 'gestalt';

type Props = {|
  repinCount: number,
|};

export default function PinHoverSocialText({ repinCount }: Props) {
  return (
    <Box alignItems="start" display="flex">
      <Box dangerouslySetInlineStyle={{ __style: { marginTop: '2px' } }}>
        <Icon accessibilityLabel="Pin" color="white" icon="pin" size={14} />
      </Box>
      <Box display="flex" maxWidth={220}>
        <Text bold color="white" inline overflow="normal" size="sm">
          <PrettyNumber shortform shortformMaximumFractionDigits={1} value={repinCount} />
        </Text>
      </Box>
    </Box>
  );
}
